import AbstractService from 'services/AbstractService';
import _ from 'lodash';

//tell eslint that Promise is a global var
/*global Promise */

/**
 * Provides CRUD services for DODs
 */
class DodService extends AbstractService {
    constructor() {
        super();
        this.DODS_FETCH_START = 'DODS_FETCH_START';
        this.DODS_FETCH_SUCCESS = 'DODS_FETCH_SUCCESS';
        this.DODS_FETCH_ERROR = 'DODS_FETCH_ERROR';
        this.DOD_VARS_FETCH_START = 'DOD_VARS_FETCH_START';
        this.DOD_VARS_FETCH_SUCCESS = 'DOD_VARS_FETCH_SUCCESS';
        this.DOD_VARS_MULTI_FETCH_SUCCESS = 'DOD_VARS_MULTI_FETCH_SUCCESS';
        this.DOD_VARS_FETCH_ERROR = 'DOD_VARS_FETCH_ERROR';
        this.baseUrl = process.env.REACT_APP_BASE_URL;
    }

    getReducer() {
        return (state = this.getInitialState(), action) => {
            let newState = state;

            switch (action.type) {
                case this.DODS_FETCH_SUCCESS:
                    newState = Object.assign({}, state);
                    let dods = null;
                    let prodDods = null;

                    if (typeof action.response === 'string') {
                        // When we load from web service, it is a string, so we have to parse it
                        dods = JSON.parse(action.response);
                    } else {
                        // When we load from local storage, it is an object (even though I did a JSON.stringify before
                        // saving - weird).  I'm not sure why this is happening - probably because the object is so large.
                        // We need to track this down eventually, but for now I am handling both cases.
                        dods = action.response.dodsById;
                        prodDods = action.response.prodDods;
                    }

                    if (!_.isEmpty(newState.dodsById)) { // dods list already exists, so we have to merge changes
                        if (!_.isEmpty(newState.prodDods)) {
                            newState.prodDods = Object.assign({}, newState.prodDods);
                        } else {
                            newState.prodDods = {};
                        }
                        newState.dodsById = Object.assign({}, newState.dodsById);

                        Object.keys(dods).forEach(datastreamName => {
                            if (!newState.dodsById[datastreamName]) {
                                newState.dodsById[datastreamName] = dods[datastreamName];
                                if (newState.dodsById[datastreamName] === true) {
                                    newState.dodsById[datastreamName] = null;
                                    newState.prodDods[datastreamName] = true;
                                }
                            }
                        });

                    } else {
                        // On first load, we need to separate out the prod dods from the full list
                        // We keep a copy of the dods list with prod status for the dependency tree since loading processes will
                        // start to fill up the dods list values with variable information, thus overwriting the 'true' value returned
                        // from the original list if the dod is production
                        newState.dodsById = dods;
                        newState.prodDods = {};
                        if (!prodDods) {
                            Object.keys(dods).forEach(datastreamName => {
                                if (newState.dodsById[datastreamName] === true) {
                                    newState.dodsById[datastreamName] = null;
                                    newState.prodDods[datastreamName] = true;
                                }
                            });
                        } else {
                            newState.prodDods = prodDods;
                        }
                    }
                    newState.sortedIds = Object.keys(newState.dodsById);
                    break;

                case this.DOD_VARS_FETCH_SUCCESS:
                    newState = Object.assign({}, state);
                    newState.dodsById = Object.assign({}, newState.dodsById);
                    newState.dodsById[action.dod] = action.response;

                    // We have to update the sorted Ids if per chance we loaded a dod on the fly
                    newState.sortedIds = Object.keys(newState.dodsById);
                    break;

                case this.DOD_VARS_MULTI_FETCH_SUCCESS:
                    newState = Object.assign({}, state);
                    newState.dodsById = Object.assign({}, newState.dodsById);
                    Object.keys(action.response).forEach(datastreamName => {
                        if (newState.dodsById[datastreamName] === null || newState.dodsById[datastreamName] === undefined) {
                            const datastreamVars = action.response[datastreamName];
                            newState.dodsById[datastreamName] = datastreamVars;
                        }
                    });
                    break;

                default:  // stupid linting rule requires a default case
                    break;
            }
            return newState;
        };
    }

    getInitialState() {
        return {
            dodsById: null,
            prodDods: null,
            sortedIds: []
        };
    }

    getStoreKey() {
        return 'dods';
    }

    fetchDodVarsIfNeeded(dod) {
        if (this._shouldFetchDodVars(dod, this.getMyState(this.getStore().getState()))) {
            this.dispatch({
                type: this.DOD_VARS_FETCH_START,
                dod
            });
        }
    }

    fetchDodsIfNeeded() {
        if (this._shouldFetchDods(this.getMyState(this.getStore().getState()))) {
            this.dispatch({
                type: this.DODS_FETCH_START
            });
        }
    }

    /**
     * Fetch if the dods have not already been loaded into the store
     * @param state - top level state (not just my sub-state)
     * @returns {boolean}
     */
    _shouldFetchDods(myState) {
        const dods = myState.dodsById;
        let shouldFetch = false;
        if (dods === null) {
            shouldFetch = true;
        }
        return shouldFetch;
    }

    _shouldFetchDodVars(dod, myState) {
        const dods = myState.dodsById;
        let shouldFetch = false;
        if (dods === null || !dods[dod]) {
            shouldFetch = true;
        }
        return shouldFetch;
    }
}

export default new DodService();



// WEBPACK FOOTER //
// ./src/services/DodService.js